import React from 'react';

const BackdropOverlay = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
            onClick={onClose}
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }}
        />
    );
};

export default BackdropOverlay;
